import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CompleteAndUnpaidDashboardTotals } from '../models/dashboard/complete-unpaid-dashboard-totals';
import { AuthHttp } from 'angular2-jwt';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtil } from '../../shared/utils/response-util';
import { AggregationBucket } from '../models/dashboard/aggregation-bucket';
import { List } from 'immutable';

@Injectable()
export class DashboardTotalsHttpService {
  private aggregateBaseURL =  '/api/events/dashboard';
  private missingAgencyCountURL: string = this.environment.baseUrl + this.aggregateBaseURL + '/missing-agency';
  private completeAndUnpaidCountURL: string = this.environment.baseUrl + this.aggregateBaseURL + '/complete-and-unpaid';

  constructor(private http: AuthHttp,
              private environment: EnvironmentConfiguration) {
  }

  getCompletedAndUnpaidCounts(): Observable<List<AggregationBucket>> {
    return this.http.get(this.completeAndUnpaidCountURL)
      .map(res => List<AggregationBucket>(res.json()))
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  getMissingAgencyCount(): Observable<number> {
    return this.http.get(this.missingAgencyCountURL)
      .map(response => Number(response.text())).catch(ResponseUtil.unwrapErrorMessage).share();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/dashboard-totals.http.service.ts